import { EEstimationTargets, IFilters } from '@cian/valuation-main-filters-widget';
import { stringify } from 'qs';

const getFiltersQsForFlats = (filters: IFilters) => ({
  address: filters.address,
  roomsCount: filters.roomsCount,
  totalArea: filters.area,
  valuationType: null,
});

const getFiltersQsForNewbuildings = (filters: IFilters) => ({
  address: filters.address,
  jkRoomsCount: filters.jkRoomsCount,
  newbuildingId: filters.newbuildingId,
});

export const getFiltersQs = (filters: IFilters) => {
  let qsObj = {};

  switch (filters.estimationTarget) {
    case EEstimationTargets.flat:
      qsObj = getFiltersQsForFlats(filters);
      break;
    case EEstimationTargets.newbuilding:
      qsObj = getFiltersQsForNewbuildings(filters);
      break;
  }

  return stringify(qsObj, { skipNulls: true });
};
